export const BRANCHING_OPTIONS = [
  {
    key: '1',
    value: 'Enabled',
  },
  {
    key: '0',
    value: 'Disabled',
  },
];

export const ASSESMENT_OPTIONS = [
  {
    key: '1',
    value: 'Enabled',
  },
  {
    key: '0',
    value: 'Disabled',
  },
];

export const SOURCE_TYPE = [
  {
    key: '1',
    value: 'Prompt',
  },
  {
    key: '2',
    value: 'Document',
  },
  {
    key: '3',
    value: 'Video',
  },
];
